import { render, staticRenderFns } from "./e-flat-icon.vue?vue&type=template&id=d487d68c"
import script from "./e-flat-icon.vue?vue&type=script&lang=js"
export * from "./e-flat-icon.vue?vue&type=script&lang=js"
import style0 from "./e-flat-icon.vue?vue&type=style&index=0&id=d487d68c&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports